import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router/router'
import store from '@/store/store'

import VuePluginInitializer from '@/app/plugins/vue-plugin-initializer'

VuePluginInitializer.init()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
